module.exports = __webpack_public_path__ + "img/banner_plp.1e4ce19.webp";